module.exports = __webpack_public_path__ + "images/d40b81fc5598fb69deb3fb23b53f0c8a-LoginBrandImg.jpg";